import type { CSSProperties } from "react";

/**
 * Inline style that puts a heading on the brand headline face (Neue Haas Unica,
 * via the `--font-heading` token). Apply to every heading/title text element in
 * Core (page, panel, section, dialog, step titles) so headings render
 * consistently in the brand headline font while body/UI stays on the body face.
 */
export function headingFontStyle(): CSSProperties {
  return { fontFamily: "var(--font-heading)" };
}
